// extracted by mini-css-extract-plugin
export default {"pagination":"pagination___cYoIB_contentrenderer"};
    if(module.hot) {
      // 1779098920186
      var cssReload = require("!../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  